export const stringifyDate = (date: string | Date) =>
{
    const actualDate = (date instanceof Date) ? date : new Date(date);
    return actualDate.toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}